import { Component, Input } from '@angular/core';
// import { Workout, Tier, TierRow } from 'fitforce-document-sync';

@Component({
  selector: 'template-library-item',
  templateUrl: './template-library-item.component.html',
  styleUrls: ['./template-library-item.component.scss']
})
export class TemplateLibraryItemComponent {
  @Input()  label: string;
  @Input() title: string;
  constructor() { }

}
